import React, { useState, useEffect, useRef } from "react";
import './Product.css';
import Navbar from "./Navbar";
import Footer from "./Footer";
import { FaExpand } from 'react-icons/fa';
import axios from "axios";



const Product = (props) => {

  const iframeRef = useRef(null); // Create a referencefor the iframe

  // Function to toggle fullscreen for the iframe
  const toggleFullscreen = () => {
    const iframe = iframeRef.current;

    // Check if the iframe is already in fullscreen
    if (iframe.requestFullscreen) {
      iframe.requestFullscreen(); // For most browsers
    } else if (iframe.mozRequestFullScreen) {
      iframe.mozRequestFullScreen(); // For Firefox
    } else if (iframe.webkitRequestFullscreen) {
      iframe.webkitRequestFullscreen(); // For Safari
    } else if (iframe.msRequestFullscreen) {
      iframe.msRequestFullscreen(); // For IE/Edge
    }
  };



  useEffect(() => {

    const now = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC + 5:30
    const istDate = new Date(now.getTime() + istOffset);

    const bodyVal = {
      firstName : props.user.firstName,
      lastName:props.user.lastName,
      email:props.user.email,
      role:props.user.role,
      organizationName: props.organization,
      dateTime:istDate,
      moduleName: props.module.title,
      comment: `${props.module.title} page open`
    }
    // Define the POST request using axios
    const postRequest = async () => {
      try {
        const response = await axios.post("https://onehum-backend.acuitas360.com/logs", bodyVal, {
          headers: {
              'Authorization': `Bearer ${props.token}`,
          },
      });

      } catch (error) {
        console.error("Error in POST request", error);
      }
    };
    postRequest();
  }, [props.user, props.organization, props.module]); 

  const Frame = () => {
    // helper to send token to iframe (uses origin from module url when possible)
    const sendTokenToIframe = () => {
      try {
        const iframe = iframeRef.current;
        if (!iframe || !iframe.contentWindow) return;
        const message = { type: 'onehum_auth', token: props.token || '' };
        let targetOrigin = '*';
        try {
          targetOrigin = new URL(props.module.url).origin;
        } catch (e) {
          // leave targetOrigin as '*'
        }
        iframe.contentWindow.postMessage(message, targetOrigin);
      } catch (err) {
        console.warn('Failed to post message to iframe', err);
      }
    };

    // If Tableau embed keep existing behaviour
    if (props.module.url.includes("online.tableau.com")) {
      return (
        <div className="_container" style={{ marginBottom: 100 }}>

          <tableau-viz id='tableauViz'
            src={props.module.url}
            hide-tabs toolbar='bottom' 
            >
          </tableau-viz>

        </div>
      )
    }

    // If the iframe belongs to acuitas domain, send the token via postMessage on load
    if (props.module.url.includes("acuitas")) {
      return (
        <div className="relative bg-white frame">
          <iframe
            src={props.module.url}
            className=" shadow-xl bg-white shadow-gray-300 border-gray-800 w-100 h-100"
            ref={iframeRef}
            onLoad={sendTokenToIframe}
            title={props.module.title}
            allow="clipboard-write"
          ></iframe>

          {/* Fullscreen button */}
          <button
            onClick={toggleFullscreen}
            className="btn absolute p-2 bg-gray-500 text-white rounded-full shadow-lg fullscreen"
          >
            <FaExpand size={24} className="" /> {/* Icon for fullscreen */}
          </button>
        </div>
      )
    }

    // Default iframe for other modules

return (
  <div className="relative bg-white frame">
    <iframe
      src={props.module.url}
      ref={iframeRef}
      className="shadow-xl bg-white shadow-gray-300 border-gray-800 w-100 h-100"
    ></iframe>
 
    {/* Fullscreen button */}
    <button
      onClick={toggleFullscreen}
      className="btn absolute p-2 bg-gray-500 text-white rounded-full shadow-lg fullscreen"
    >
      <FaExpand size={24} />
    </button>
  </div>
);

  }

  return (
    <div>
      <Navbar module={props.module} user={props.user} logout={props.logout} />

        <Frame />

      <Footer />
    </div>
  );
};

export default Product;
